'use strict';
// eslint-disable-next-line no-unused-vars
import raven from 'raven';

import { TransitionsStore } from 'app/components/states-template/states-template.controller';
import SimpleMessages from 'app/controllers/simple-messages';

import OPPostponeDialogController from './op-postpone.dialog.controller';
import OPPostponeDialogTpl from './op-postpone.dialog.html';

import OPDoneDialogController from './op-done.dialog.controller';
import OPDoneDialogTpl from './op-done.dialog.html';

export default class OperationProcedureController {
  /* @ngInject */
  constructor(
    OperationProceduresService,
    $mdDialog,
    $mdToast,
    $mdExpansionPanel
  ) {
    Object.assign(this, {
      OperationProceduresService,
      $mdDialog,
      $mdToast,
      $mdExpansionPanel
    });
  }

  $onInit() {
    this.updateModel();
    if (this.isOpen) {
      this.$mdExpansionPanel()
        .waitFor(this.model.id)
        .then(instance => instance.expand());
    }
  }

  updateModel() {
    const op = this.model;
    const txsStore = new TransitionsStore(op.transitions, op.state);
    op.drawables = txsStore.getTransitions();

    for (const tx of op.drawables) {
      const ophs = op.operationProcedureHistories.filter(
        oph => tx.to == oph.state
      );
      tx.ophs = tx.ophs.concat(ophs);

      const task = op.tasks.find(task => tx.to == task.state);
      tx.task = task;
    }
    const candidate = op.drawables.find(d => d.isCandidate);
    this.candidate = candidate;
    const current = op.drawables.find(d => d.isCurrent);
    this.current = current;
  }

  next() {
    const confirm = this.$mdDialog.show({
      controller: OPDoneDialogController,
      template: OPDoneDialogTpl,
      clickOutsideToClose: true,
      fullscreen: true,
      locals: {
        completedAt: this.model.currentTask.completedAt,
        onComplete: this.candidate.onComplete
      }
    });

    confirm.then(
      data => {
        this.showProcedureSpin = true;
        this.OperationProceduresService.next({
          completedAt: data.completedAt,
          comments: data.comments,
          opId: this.model.id
        })
          .then(res => {
            Object.assign(this.model, res.operationProcedure);
            return this.OperationProceduresService.find({
              where: {
                operationId: this.model.operationId,
                id: {
                  neq: this.model.id
                }
              },
              include: [
                {
                  relation: 'operationProcedureHistories',
                  scope: {
                    include: ['createdByUser']
                  }
                },
                'currentTask',
                'tasks'
              ]
            });
          })
          .then(
            operationProcedures => {
              this.onNewOp({
                $event: {
                  operationProcedures
                }
              });
              this.showProcedureSpin = false;
              this.simpleSuccess();
              this.updateModel();
            },
            err => {
              raven.captureException(err);
              this.simpleError();
            }
          );
      },
      () => {
        // pass
      }
    );
  }

  stay() {
    const confirm = this.$mdDialog
      .prompt()
      .title('Tarea no hecha')
      .textContent('Ingrese comentarios')
      .placeholder('Comentarios')
      .ariaLabel('Comentarios')
      .required(true)
      .ok('Aceptar')
      .cancel('Cancelar');

    this.$mdDialog.show(confirm).then(
      comments => {
        this.showProcedureSpin = true;
        return this.OperationProceduresService.stay({
          comments: comments,
          opId: this.model.id
        }).then(
          res => {
            Object.assign(this.model, res.operationProcedure);
            this.showProcedureSpin = false;
            this.simpleSuccess();
            this.updateModel();
          },
          err => {
            raven.captureException(err);
            this.simpleError();
          }
        );
      },
      () => {
        // pass
      }
    );
  }

  postpone() {
    const dialog = this.$mdDialog.show({
      controller: OPPostponeDialogController,
      template: OPPostponeDialogTpl,
      clickOutsideToClose: true,
      fullscreen: true,
      locals: {
        dueAt: this.model.currentTask.dueAt
      }
    });
    dialog.then(
      data => {
        this.showProcedureSpin = true;
        return this.OperationProceduresService.postpone({
          comments: data.comments,
          dueAt: data.dueAt,
          opId: this.model.id
        }).then(
          res => {
            Object.assign(this.model, res.operationProcedure);
            this.showProcedureSpin = false;
            this.simpleSuccess();
            this.updateModel();
          },
          err => {
            raven.captureException(err);
            this.simpleError();
          }
        );
      },
      () => {}
    );
  }

  prev() {
    const confirm = this.$mdDialog
      .prompt()
      .title('Volver a situación anterior')
      .textContent('Ingrese comentarios')
      .placeholder('Comentarios')
      .ariaLabel('Comentarios')
      .required(true)
      .ok('Aceptar')
      .cancel('Cancelar');

    this.$mdDialog.show(confirm).then(
      comments => {
        this.showProcedureSpin = true;
        return this.OperationProceduresService.prev({
          comments: comments,
          opId: this.model.id
        }).then(
          res => {
            Object.assign(this.model, res.operationProcedure);
            this.showProcedureSpin = false;
            this.simpleSuccess();
            this.updateModel();
          },
          err => {
            raven.captureException(err);
            this.simpleError();
          }
        );
      },
      () => {
        // pass
      }
    );
  }

  deactivate() {
    const confirm = this.$mdDialog
      .prompt()
      .title('Desactivar trámite')
      .textContent('Ingrese comentarios')
      .placeholder('Comentarios')
      .ariaLabel('Comentarios')
      .required(true)
      .ok('Aceptar')
      .cancel('Cancelar');

    this.$mdDialog.show(confirm).then(
      comments => {
        this.showProcedureSpin = true;
        return this.OperationProceduresService.deactivate({
          comments: comments,
          opId: this.model.id
        }).then(
          res => {
            Object.assign(this.model, res.operationProcedure);
            this.showProcedureSpin = false;
            this.simpleSuccess();
            this.updateModel();
          },
          err => {
            raven.captureException(err);
            this.simpleError();
          }
        );
      },
      () => {
        // pass
      }
    );
  }

  reactivate() {
    const confirm = this.$mdDialog
      .prompt()
      .title('Reactivar trámite')
      .textContent('Ingrese comentarios')
      .placeholder('Comentarios')
      .ariaLabel('Comentarios')
      .required(true)
      .ok('Aceptar')
      .cancel('Cancelar');

    this.$mdDialog.show(confirm).then(
      comments => {
        this.showProcedureSpin = true;
        return this.OperationProceduresService.reactivate({
          comments: comments,
          opId: this.model.id
        }).then(
          res => {
            Object.assign(this.model, res.operationProcedure);
            this.showProcedureSpin = false;
            this.simpleSuccess();
            this.updateModel();
          },
          err => {
            raven.captureException(err);
            this.simpleError();
          }
        );
      },
      () => {
        // pass
      }
    );
  }
}

Object.assign(OperationProcedureController.prototype, SimpleMessages);
